/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { PaginatedMomcListListResponse } from '../types/PaginatedMomcListList';

import type { UseResource } from '../../hooks/useResource';
import { useResource } from '../../hooks/useResource';

export type MomcListRequest = {} | null | undefined;
export type MomcListResponse = PaginatedMomcListListResponse;

export type MomcListQuery = {
  /**
   * ```yaml
   * in: query
   * name: name__icontains
   * schema:
   *   type: string
   * ```
   */
  name__icontains?: string;

  /**
   * ```yaml
   * name: page
   * required: false
   * in: query
   * description: A page number within the paginated result set.
   * schema:
   *   type: integer
   * ```
   */
  page?: number;
};

/**
 * GET /dmx-server/momc/
 *
 * ```yaml
 * operationId: momc_list
 * tags:
 *   - momc
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PaginatedMomcListList'
 *     description: ''
 * ```
 */
export const momcListOperation = (rest?: MomcListQuery | null) =>
  ({
    method: 'GET',
    path: `/dmx-server/momc/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'GET';
    path: string & { _templateUrl: '/dmx-server/momc/' };
  };

/**
 * GET /dmx-server/momc/
 *
 * ```yaml
 * operationId: momc_list
 * tags:
 *   - momc
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PaginatedMomcListList'
 *     description: ''
 * ```
 */
export const momcList = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query?: MomcListQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<PaginatedMomcListListResponse>> => {
  const operation = momcListOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'GET',
    request,
    onUploadProgress,
    cancelToken,
  );
};

/**
 * GET /dmx-server/momc/
 */
export const useMomcListResource = (
  query: MomcListQuery | null,
  useCached?: boolean,
): UseResource<MomcListResponse> => {
  return useResource<MomcListResponse>({
    path: query === null ? null : momcListOperation(query).path,
    apiUrl: globalThis.DMX_CONFIG.server,
    useCached,
  });
};
